import React, {useState, useEffect} from 'react'

import "./Behaviours.css"
import TextField from '@mui/material/TextField';
import ColorPicker from '../../shared/colorpicker/ColorPicker';
import axios from 'axios';
import ValidationMessage from '../../shared/validationmessage/ValidationMessage';

const model = {
  modulename: "Behaviour Editor"
};

const BehaviourEditor = (props) => {

  /* data handling */
  const data = props.data.data;
  const [Id, setId] = useState(data.Id);
  const [SequenceNumber, setSequenceNumber] = useState(data.SequenceNumber);
  const [Name, setName] = useState(data.Name);
  const [Definition, setDefinition] = useState(data.Definition);
  const [Color, setColor] = useState(data.Color);

  const [image, setImage] = useState(axios.defaults.baseURL + '/' + data.ImageUrl);
  const [file, setFile] = useState();

  /* exceoption handling */
  const [validations, setValidations] = useState({
      SequenceNumber: [],
      Name: [],
      Definition: []
  });

  const resetValidations=()=>{
    setValidations({
      SequenceNumber: [],
      Name: [],
      Definition: []
    });
    props.setErrors("");
  }

  const parseErrorResponse=(response)=>{
    if(response.data.errors){
      props.setErrors("");
      setValidations(response.data.errors);
    }
  }

  const handleCancelClick = () => {
    props.setEditorState({open: false, data: null});
  };

  const handleSubmitClick =(e)=>{
    e.preventDefault();

    axios.post('/behaviours/update', {
      Id: Id,
      SequenceNumber: SequenceNumber,
      Name: Name,
      Definition: Definition,
      Color: Color
    })
    .then(function (response) {
      resetValidations();

      if(response.data.status == "success"){
        props.setErrors("");
        uploadFileToServer(response);
      }
      else{
        props.setErrors(response.data.message);
      }
    })
    .catch(function (error) {
      if(error.message){
        props.setErrors(error.message);
      }
      else{
        parseErrorResponse(error.response);
      }
    });
  };

  const uploadFileToServer=(response)=>{
    if(file){
      const formData = new FormData();
      formData.append('Id', Id);
      formData.append('formFile', file);
      axios.post('/behaviours/upload', formData,{
        headers: {
          "Content-Type": "multipart/form-data",
        }
      })
      .then(function (response) {
        if(response.data.status == "success"){
          props.setEditorState({open: false, data: null});
          props.setPageState({loading: false});
        }
        else{
          props.setErrors(response.data.message);
        }
      })
      .catch(function (error) {
        props.setErrors(error.message);
      });
    }
    else{
      props.setEditorState({open: false, data: null});
      props.setPageState({loading: false});
    }
  }

  const handleFileChange =(e)=>{
    setImage(URL.createObjectURL(e.target.files[0]));
    setFile(e.target.files[0]);
  }

  return (
    <form className="form">
        <div className="mb-3">
          <img src={image} alt={Name}/>
          <label className="upload-file">
            <input type="file" className="d-none" onChange={handleFileChange}/>  Browse file...
          </label>      
        </div>
        <div className="mb-3">
          <TextField
            className="form-control"
            label="Sequence"
            type="number"
            value={SequenceNumber}
            onChange={e=> setSequenceNumber(e.target.value)}
          />
          <ValidationMessage field="SequenceNumber" errors={validations}/>
        </div>
        <div className="mb-3">
          <TextField
            className="form-control"
            label="Behavior"
            value={Name}
            onChange={e=> setName(e.target.value)}
            inputProps={{maxLength :500}}
          />
          <ValidationMessage field="Name" errors={validations}/>
        </div>
        <div className="mb-2">
        <TextField
            required
            multiline
            rows={3}
            className="form-control"
            label="Definition"
            value={Definition}
            onChange={e=> setDefinition(e.target.value)}
          />
          <ValidationMessage field="Definition" errors={validations}/>
          </div>
          <div className="mb-2">
          <div className="wrapper">
            <div className="Color-setting"><label>Color</label><ColorPicker setColor={setColor} color={Color} /></div>
          </div>
          </div>
        
        <div className="btns">
          <button type="button" className="btn btn-primary" onClick={handleSubmitClick} >Save</button>&nbsp;
          <a className="btn btn-secondary" onClick={handleCancelClick}>Cancel</a>
        </div>
      </form>
  )
}

export default BehaviourEditor

